/**
 * Meta (Facebook) Pixel — centralized implementation.
 *
 * Flow for this funnel: PageView → InitiateCheckout → Shopify checkout → Purchase
 * (Purchase is tracked by Shopify, never from this landing page).
 */
export const metaPixelId = '676572141744167'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[][]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
    __metaPixelInitialized?: boolean
  }
}

function loadPixelScript() {
  if (window.fbq) return

  const fbq: Fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
    } else {
      fbq.queue?.push(args)
    }
  } as Fbq

  fbq.queue = []
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.push = fbq

  window.fbq = fbq
  window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)
}

/**
 * Initializes the pixel and sends a single PageView per real page load.
 * Guarded on `window`, so React re-renders, remounts and StrictMode's double
 * effect invocation cannot produce duplicate init or PageView calls.
 */
export function initMetaPixel() {
  if (typeof window === 'undefined' || !metaPixelId) return
  if (window.__metaPixelInitialized) return

  window.__metaPixelInitialized = true
  loadPixelScript()
  window.fbq?.('init', metaPixelId)
  window.fbq?.('track', 'PageView')
}

/** Sends a standard Meta event. */
export function trackPixelEvent(event: string, params?: Record<string, unknown>) {
  if (typeof window === 'undefined' || !metaPixelId || !window.fbq) return
  window.fbq('track', event, params)
}

/**
 * Shared handler for every CTA that sends the visitor straight to the Shopify
 * checkout. Fires InitiateCheckout once per click, then lets the normal link
 * navigation continue to the unchanged checkout URL.
 */
export function trackInitiateCheckout() {
  trackPixelEvent('InitiateCheckout', {
    value: 19.99,
    currency: 'USD',
    content_name: 'Little Engineer Mega Kit EN',
    content_category: 'Digital Product',
  })
}
